import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Typography, Box, Theme } from '@mui/material';

const useStyles = makeStyles()((theme: Theme) => {
	return {
		root: {
			padding: '12px 0',
			borderBottom: '1px solid #E0E0E0',
			marginBottom: theme.spacing(2),
			flexGrow: 1,

			'& .MuiTypography-root:not(.MuiTypography-subtitle1)': {
				fontWeight: 600,
				fontSize: '1.8rem',
				lineHeight: '2.4rem',
			},
			[theme.breakpoints.up('sm')]: {
				borderBottom: 'none',
				marginBottom: 0,

				'& .MuiTypography-root:not(.MuiTypography-subtitle1)': {
					fontSize: '2.8rem',
					lineHeight: '3.6rem',
				},
			},
		},
	};
});

const Heading = (props: any) => {
	const { label, children, className } = props;
	const { classes, cx } = useStyles();

	return (
		<Box className={cx(classes.root, className)}>
			<Typography variant="h2">{label}</Typography>
			{children}
		</Box>
	);
};

export default Heading;
